import { apiFetch } from '../utils/api';

export interface ActivityLog {
  id: string;
  userId: string | null;
  userName?: string | null;
  action: string;
  entityType: string;
  entityId: string;
  details?: Record<string, unknown> | null;
  createdAt: string;
}

export interface PaginatedActivityLogsResponse {
  data: ActivityLog[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchActivityLogs = (params: { page?: number; limit?: number } = {}) => {
  const sp = new URLSearchParams();
  if (params.page) sp.set('page', String(params.page));
  if (params.limit) sp.set('limit', String(params.limit));
  const q = sp.toString();
  return apiFetch<PaginatedActivityLogsResponse>(`/activity-logs${q ? `?${q}` : ''}`);
};
